export default __webpack_public_path__ + "static/media/SECONDARY-FONT.afd99376.png";